export default __webpack_public_path__ + "img/ca109a3c94c49038482e01cefa474f83.svg";